import { useAtomValue } from "jotai";
import { ChatDrawerWrapper as ChatDrawer } from "../../components";
import { TrackingEvents, sendLoggingEvents } from "../../events";
import { isChatErrorAtom } from "../../session";
import {
  currentConversationAtom,
  currentConversationMessagesAtom,
  currentConversationParticipantNamesAtom,
} from "../../session/state";
import { connectedAtAtom } from "../../video-sdk";
import { twilioIdentityAtom } from "../../video-sdk/twilio";
import {
  doesClientRequireSafetyGuardsAtom,
  VisitorState,
  visitorStateAtom,
} from "../state";
import { SAFETY_GUARD_BANNER_TEXT } from "./constants";

export function ChatDrawerWrapper() {
  const chatName = useAtomValue(currentConversationParticipantNamesAtom).join(
    ", ",
  );
  const conversation = useAtomValue(currentConversationAtom);
  const messages = useAtomValue(currentConversationMessagesAtom);
  const identity = useAtomValue(twilioIdentityAtom);
  const connectedAt = useAtomValue(connectedAtAtom);
  const visitorState = useAtomValue(visitorStateAtom);
  const isChatError = useAtomValue(isChatErrorAtom);
  const doesClientRequireSafetyGuards = useAtomValue(
    doesClientRequireSafetyGuardsAtom,
  );
  const sendMessage = (message: string) => {
    sendLoggingEvents(TrackingEvents.ANY_MESSAGE_SEND);
    sendLoggingEvents(TrackingEvents.CLIENT_MESSAGE_SEND);
    if (visitorState === VisitorState.MEETING) {
      sendLoggingEvents(TrackingEvents.ANY_SESSION_MESSAGE_SEND);
    }
    if (visitorState === VisitorState.WAITING) {
      sendLoggingEvents(TrackingEvents.ANY_WAITING_ROOM_MESSAGE_SEND);
    }
    conversation?.sendMessage(message);
  };
  const footerText = !connectedAt
    ? "Your provider may be in a session with another client and will respond as soon as possible."
    : undefined;

  return (
    <ChatDrawer
      chatName={chatName}
      identity={identity}
      messages={messages}
      isError={isChatError}
      onSend={sendMessage}
      connectedAt={connectedAt}
      footerText={footerText}
      warningBannerText={
        doesClientRequireSafetyGuards ? SAFETY_GUARD_BANNER_TEXT : undefined
      }
    />
  );
}
